import React from 'react';
import { PageLayout } from '~/common/components';
import { SearchViewModel } from './models';
import SearchBar from './components/search-bar';

import { SearchStore } from './components/search-provider';
import SearchContents from './components/search-content';

// The AI answering mode (overview card, AI Mode tab + conversational view)
// lives INSIDE SearchContents so it shares the results column and the
// results header's tab row. All of it is CMS-gated (enableAiMode).
const Search = (props: SearchViewModel) => {
  return (
    <div id="search-page">
      <SearchStore {...props}>
        <PageLayout>
          <SearchBar />
          <SearchContents />
        </PageLayout>
      </SearchStore>
    </div>
  );
};

export default Search;
